<template>
<div class="chapter">
<div class="inner_page">
<div class="preface">
<p class="nonindent"><em>In every espionage operation there is an above the line and a below the line. Above the line is what you do by the book. Below the line is how you do the job</em>.</p>
<p class="right">—<em>John le Carré</em>, A Perfect Spy</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312375942_epub_fm_r1.vue?231559b0